export enum AnalyticsId {
  add_debt = 'add-debt',
}
